import React from 'react';
import { useTheme } from '../contexts';
import PianoIcon from './icons/PianoIcon';
import PencilIcon from './icons/PencilIcon';

interface ModeToggleProps {
  mode: 'builder' | 'custom';
  onToggle: () => void;
}

const ModeToggle: React.FC<ModeToggleProps> = ({
  mode,
  onToggle,
}) => {
  const { theme } = useTheme();
  const isCustomMode = mode === 'custom';

  return (
    <button
      onClick={onToggle}
      className="mode-toggle-button"
      style={{
        width: '54px',
        height: '32px', // Increased from 20px to match button height
        borderRadius: `${theme.radii.full}px`,
        padding: '3px', // Increased from 2px
        position: 'relative',
        backgroundColor: isCustomMode ? theme.colors.key : theme.colors.primary,
        border: 'none',
        cursor: 'pointer',
        transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
      }}
      title={isCustomMode ? 'Switch to Builder' : 'Switch to Custom'}
    >
      <div
        style={{
          width: '26px', // Increased from 16px
          height: '26px', // Increased from 16px
          borderRadius: `${theme.radii.full}px`,
          backgroundColor: theme.colors.background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'absolute',
          left: isCustomMode ? 'calc(100% - 29px)' : '3px', // Adjusted for new size
          top: '3px',
          transition: `all ${theme.motion.duration.fast}ms ${theme.motion.easing.standard}`,
        }}
      >
        {isCustomMode ? (
          <PencilIcon
            size={14} // Increased from 10
            color={theme.colors.key}
          />
        ) : (
          <PianoIcon
            size={14} // Increased from 10
            color={theme.colors.primary}
          />
        )}
      </div>
    </button>
  );
};

export default ModeToggle;
